export const GLOBAL_STATE = 'Staff'

export const STAFF = 'staff'
export const STAFF_LIST = 'staffList'
export const STAFF_USERNAME = 'staffUsername'
export const STAFF_ALL = 'staffAll'
